// @flow

import React from 'react';
import { connect } from 'react-redux';
import { ExtraContract } from './atoms';
import { TilesColumn, TileSelect } from '../tileSelect';
import { getExtraContracts } from '../../../../store/configuration';
// import type { State } from '../../../../types';
import type { ExtraContract as ExtraContractType } from '../../../../types/pdb';

type StateProps = {|
  extraContracts: Array<ExtraContractType>,
|};

type Props = StateProps;

const ExtraContracts = ({ extraContracts }: Props) => {
  const components = extraContracts && extraContracts.map(extraContract => (
    <ExtraContract
      blockCount={extraContracts.length}
      extraContract={extraContract}
      key={`extracontract-${extraContract.id}`}
    />
  ));

  return (
    <TileSelect>
      <TilesColumn>{components}</TilesColumn>
      <TilesColumn>{components}</TilesColumn>
    </TileSelect>
  );
};

const mapStateToProps = (state: any): StateProps => ({
  extraContracts: getExtraContracts(state),
});

export default connect<any, void, StateProps, any, any, any>(mapStateToProps)(ExtraContracts);
